
import { USER_ACTIONS, USER_GETTERS } from "@/store/user";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import MessageModal from "@/components/info/MessageModal.vue";
import ConfirmModal from "@/components/info/ConfirmModal.vue";
import { BASE_GETTERS, BASE_MUTATIONS } from "@/store";
import PageLoader from "@/components/helpers/PageLoader.vue";
import TransactionsToast from "@/components/info/TransactionsToast.vue";
import { ROUTES } from "@/router/constants";
import SidebarMobile from "@/components/base/SidebarMobile.vue";
import SidebarCommon from "@/components/base/SidebarCommon.vue";
import { REFERRAL_ACTIONS } from "@/store/referral";
import { useRoute } from "vue-router";
import { MEME_ACTIONS, MEME_GETTERS } from "@/store/meme";
import { VOTE_ACTIONS } from "@/store/vote";
import VotesSubmit from "@/components/info/VotesSubmit.vue";
import ELROND from "@/constants/elrond";
import BLOCKCHAIN from "@/constants/blockchain";
import ShutdownBanner from "@/components/base/ShutdownBanner.vue";

export default {
  name: "App",
  components: {
    SidebarCommon,
    SidebarMobile,
    TransactionsToast,
    PageLoader,
    ConfirmModal,
    MessageModal,
    VotesSubmit,
    ShutdownBanner,
  },
  created() {
    this.ROUTES = ROUTES;
  },
  setup() {
    const store = useStore();
    const account = computed(() => store.getters[USER_GETTERS.ACCOUNT_ELROND]);
    const address = computed(() => store.getters[USER_GETTERS.ADDRESS_ELROND]);
    const theme = computed(() => store.getters[BASE_GETTERS.THEME]);

    const loading = ref(true);

    onMounted(async () => {
      loading.value = true;

      try {
        await store.dispatch(REFERRAL_ACTIONS.HANDLE_REFERER);

        await store.dispatch(USER_ACTIONS.LOGIN_RECHECK);
      } catch (e) {
        console.error(e);

        store.commit(BASE_MUTATIONS.MESSAGE_MODAL, {
          variant: "danger",
          message: "messages.error.general",
        });
      }

      // Memes related
      try {
        await store.dispatch(MEME_ACTIONS.GET_CURRENT_PERIOD);
        await store.dispatch(MEME_ACTIONS.GET_RESTRICTED);

        loading.value = false;
      } catch (e) {
        console.error(e);

        loading.value = null;

        store.commit(BASE_MUTATIONS.MESSAGE_MODAL, {
          variant: "danger",
          message: "messages.error.general",
        });
      }

      loading.value = false;
    });

    // Get the account referer
    watch(account, (value, oldValue) => {
      if (value && value !== oldValue) {
        store.dispatch(REFERRAL_ACTIONS.GET_REFERER, value);
      }
    });

    const route = useRoute();

    // Memes Related
    const currentPeriod = computed(() => store.getters[MEME_GETTERS.CURRENT_PERIOD]);

    watch([address, account, currentPeriod], () => {
      if (!address.value || !account.value || !currentPeriod.value) {
        return;
      }

      store.dispatch(VOTE_ACTIONS.GET_USER_REMAINING, address.value);
      store.dispatch(USER_ACTIONS.GET_TOKEN_BALANCE, { token: BLOCKCHAIN.TOKEN_IDENTIFIER });
      store.dispatch(USER_ACTIONS.GET_TOKEN_BALANCE, { token: BLOCKCHAIN.TOKEN_IDENTIFIER_WEGLD });
    });

    return {
      address,
      theme,
      loading,
      route,
    };
  },
};
